<template>
  <div id="mail_auth">
    <div class="mail_auth_content">
      <h1>E-mail 認證</h1>
      <p>請至您註冊的E-Mail中收取上聯發送的「E-Mail認證信」，並輸入信件中提供的『認證碼』</p>
      <p>若過了5分鐘您都沒有收到通知信，可能是E-mail有防火牆阻擋、被過濾至垃圾信箱中，請先至「<span>垃圾信匣</span>」查看，並檢查您的信箱設定後再試試</p>
      <p>若還是沒有收到，請點選「<span>重發認證信</span>」重新進行認證</p>
      <p>若有任何問題，請與客服中心聯絡，由專人為您處理</p>
    </div>
    <div class="mail_auth_box">
      <Title title_name = "您的E-Mail(帳號)"></Title>
      <div>
        <p v-if="email">{{email}}</p>
        <p v-if="getMail">驗證信已發送完成</p>
        <MoreButton button_text="重發驗證信" button_href="javascript:void(0);" @click.native="email_auth(email)"></MoreButton>
      </div>
    </div>
    <div class="notice">
      <p>※ 請注意：您必須完成「E-Mail認證」，才能確保您能成功索取票券&報名活動！</p>
    </div>
  </div>
</template>
<script>
import Title from '@/components/base/Title'
import MoreButton from '@/components/base/MoreButton'
export default {
  
  data() {
    return {
      email: this.$route.params.email,
      getMail: false
    }
  },
  components:{
    Title: Title,
    MoreButton: MoreButton,
  },
  computed: {
    API(){
      return process.env.NODE_ENV === "production" ? "https://www.top-link.com.tw/" : "http://localhost/";
    }
  },
  methods: {
    email_auth(email){
      var vm = this
      var email_api = vm.API + 'api/member/approve'
      var data = {
        email: email
      }
      vm.axios.post(email_api, data).then(res => {
        res.data.status == 200 ? vm.getMail = true : alert("錯誤碼: " + res.data.status + " " + res.data.message)
      }).catch(function(error) {
          console.log(error)
        })
    }
  },
}
</script>
<style>
#mail_auth{
  width: 1000px;
  max-width: 100%;
  margin: auto;
  padding: 10px;
}
#mail_auth .title h4{
  background: #004cb9;
  color: #ffffff;
  font-size: 19px;
  height: auto;
  padding: 10px 0;
}
#mail_auth .more_button{margin: 0; padding-bottom: 10px;}
.mail_auth_content>p{
  font-size: 19px;
  line-height: 1.8;
  text-align: justify;
}
.mail_auth_content>p span{ font-weight: bold;}

.mail_auth_box{
  width: 400px;
  max-width: 100%;
  margin: auto;
  background: blanchedalmond;
  border-radius: 20px;
}
.mail_auth_box div {
  text-align: center;
}
.mail_auth_box div p{
  font-size: 19px;
  font-weight: 400;
  padding: 0;
}
.notice p{
  text-align: center;
  color: red;
  font-size: 21px;
  font-weight: bold;
}
</style>